import { TFunction } from 'i18next';
import { EMAIL_REGEX, URL_REGEX } from 'lib/utils/regexes';
import * as Yup from 'yup';

export const annotationTypes = {
  ANNOTATION_TEXT: 'text',
  ANNOTATION_IMAGE: 'image',
};

export const getLinkOptions = (t: TFunction) => {
  return [
    { label: t('No URL'), value: 'No URL' },
    { label: t('Web'), value: 'Web' },
    { label: t('Email'), value: 'Email' },
    { label: t('Phone'), value: 'Phone' },
  ];
};
export const getTypeValues = (t: TFunction) => {
  const labelForText = t(
    annotationTypes.ANNOTATION_TEXT.charAt(0).toUpperCase() +
      annotationTypes.ANNOTATION_TEXT.slice(1)
  );
  return [
    {
      value: annotationTypes.ANNOTATION_TEXT,
      text: labelForText,
    },
    {
      value: annotationTypes.ANNOTATION_IMAGE,
      text: t('Logo'),
    },
  ];
};

export const annotationsSchema = (t: (key: string) => string) =>
  Yup.object({
    position: Yup.string().required('Required'),
    url: Yup.string().test(
      'isUrl',
      t('URL is not valid'),
      function (value = '') {
        if (!value) {
          return true;
        }
        if (this.parent && this.parent.linkType !== 'Web') {
          return true;
        }
        console.log('Validating URL:', value, value.match(URL_REGEX));
        return value.match(URL_REGEX);
      }
    ),
    email: Yup.string().test(
      'isEmail',
      t('Email is not valid'),
      function (value = '') {
        if (!value) {
          return true;
        }

        if (this.parent && this.parent.linkType !== 'Email') {
          return true;
        }
        console.log('Validating email:', value, value.match(EMAIL_REGEX));
        return value.match(EMAIL_REGEX);
      }
    ),
    phone: Yup.string().test(
      'isPhone',
      t('Phone is not valid'),
      function (value = '') {
        if (!value) {
          return true;
        }
        if (this.parent && this.parent.linkType !== 'Phone') {
          return true;
        }
        console.log(
          'Validating phone:',
          value,
          value.match(/^[0-9()\-.\s]+$/i)
        );
        return value.match(/^[0-9()\-.\s]+$/i);
      }
    ),
  });
